'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject_es = require('../lib/style-inject/dist/style-inject.es.js');

var css_248z = ".Toastify__toast-container{padding:0}.Toastify__toast{cursor:default;min-height:0;padding:0;width:25rem}.Toastify__toast-body{flex:1 1 100%;padding:.375rem .5rem}@media screen and (max-width:402px){.Toastify__toast{width:100vw}}";
styleInject_es["default"](css_248z);

exports["default"] = css_248z;
//# sourceMappingURL=ToastOverload.scss.js.map
